


























import { Component, Vue, Prop } from 'vue-property-decorator';
import { BaseDashboardPageField, DashboardPageFieldType } from '@/models/hcad/shared/dashboard';
import { fieldEditorComponents } from '@/utils/typed-configs';
import { validateRefs } from '@/utils/validate-refs';

// TODO: Automate this...?
require('./field-configurators/NullFieldEdit.vue');

@Component
export default class FieldEdit extends Vue
{
    @Prop({type: Object, required: true})
    field!: BaseDashboardPageField;

    rules = {
        required: (value: string) => (!!value && value.trim().length > 0) || 'This field is required',
        url: () => true,
        requiredOrOther: (other: string | null) => (value: string)=>
        {
            if (!!other && other.trim().length > 0) return true;
            return (!!value && value.trim().length > 0) || 'This field is required';
        }
    };

    get isReference()
    {
        return this.field.type === DashboardPageFieldType.Reference;
    }

    get typeString()
    {
        return DashboardPageFieldType[this.field.type];
    }

    get editorComponent()
    {
        return fieldEditorComponents.getComponent(this.field.type);
    }

    validate()
    {
        return validateRefs(this.$refs);
    }
}
